import { useOasisBackend } from '../../hooks/useOasisBackend';
import { IconTrash, IconDownload } from '@tabler/icons-react';
import { Document } from '../../api/OasisBackendApi';
import TesseractLoader from '../ui/tesseract-loader';
import { useState } from 'react';
import {toast} from 'react-toastify';

interface DocumentListProps {
  DatabaseId: string;
  onDelete: (documentId: string) => void;
  documents: Document[];
}

const DocumentList: React.FC<DocumentListProps> = ({ onDelete, documents, DatabaseId }) => {
  const db = useOasisBackend();
  const [loading, setLoading] = useState(false);

  const handleDownloadDocument = async (documentId: string) => {
    setLoading(true);
    try {
      const response = await db.endpoints.api.apiDocumentsRetrieve(documentId);
      const url = response.data.raw_document_presigned_url;
      window.open(url, '_blank');
    } catch (error) {
      console.error('Error downloading document:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleDeleteDocument = async (documentId: string) => {
    try {
      await db.endpoints.api.apiDocumentsDestroy(documentId);
      onDelete(documentId);
    } catch (error) {
      console.error('Error deleting document:', error);
    }
  };

  const retryDocumentParsing = async (DatabaseId: string) => {
    try {
      const response = await db.endpoints.api.apiDatabaseRetryDocumentParsingCreate(DatabaseId);
      toast.success("Document parsing retried");
    } catch (error) {
      console.error('Error retrying document parsing:', error);
      toast.error("Error retrying document parsing");
    }
  }

  return (
    <div className="flex flex-col gap-2">
        <h3 className="text-white text-base sm:text-lg">Documents</h3>
        {loading && <TesseractLoader />}
        {
          documents.some((document) => document.parsing_status === "document_parsing_failed") && (
            <button 
              onClick={() => retryDocumentParsing(DatabaseId)}
              className="mb-3 px-3 sm:px-4 py-2 bg-yellow-600 hover:bg-yellow-700 text-white rounded text-sm sm:text-base"
            >
              Retry Document Parsing
            </button>
          )
        }
        {!loading && <ul className="divide-y divide-gray-700 bg-gray-800 rounded-lg overflow-hidden">
        {documents.map((document) => (
          <li
          key={document.id}
          className="flex flex-col sm:flex-row sm:items-center sm:justify-between py-3 px-3 sm:px-4 hover:bg-gray-700"
        >
          <div className="flex-1 mb-3 sm:mb-0">
            <p className="text-sm font-medium text-gray-200 mb-1">{document.name}</p>
            <p className="text-xs sm:text-sm text-gray-400 mb-1">Type: {document.file_type}</p>
            <p className="text-xs sm:text-sm text-gray-400 mb-1">Indexing: {document.entity_indexing_status}</p>
            <p className="text-xs sm:text-sm text-gray-400 mb-1">Parsing: {document.parsing_status}</p>
            <p className="text-xs sm:text-sm text-gray-400">
              {new Date(document.created_at).toLocaleDateString()}
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button 
              onClick={() => handleDownloadDocument(document.id)}
              className="p-2 text-gray-400 hover:text-blue-400 rounded-full hover:bg-gray-700 transition-colors"
              aria-label="Download document"
            >
              <IconDownload size={18} className="sm:w-5 sm:h-5" />
            </button>
            <button
              onClick={() => handleDeleteDocument(document.id)}
              className="p-2 text-gray-400 hover:text-red-400 rounded-full hover:bg-gray-700 transition-colors"
              aria-label="Delete document"
            >
              <IconTrash size={18} className="sm:w-5 sm:h-5" />
            </button>
          </div>
        </li>
      ))}
    </ul>}
    </div>
  );
};

export default DocumentList;